// extracted by mini-css-extract-plugin
module.exports = {"dashboard":"PatientList_dashboard__27lSt","list":"PatientList_list__1sr45","label":"PatientList_label__3Amv7"};